// features/ApprovalRequest/ApprovalRequestAddEditView/valid.ts
import {
  CheckEmptyTextField,
  CheckIsNumber,
} from "components/ValidationHelper";
import store from "./store";

export const validate = (event: { target: { name: string; value: any } }) => {
  let organization_id = "";
  if (event.target.name === "organization_id") {
    let organization_idErrors = [];
    CheckEmptyTextField(event.target.value, organization_idErrors);
    CheckIsNumber(event.target.value, organization_idErrors);
    organization_id = organization_idErrors.join(", ");
    store.errororganization_id = organization_id;
  }

  let bga_application_number = "";
  if (event.target.name === "bga_application_number") {
    let bga_application_numberErrors = [];
    // BGA Application Number может быть необязательным
    bga_application_number = bga_application_numberErrors.join(", ");
    store.errorbga_application_number = bga_application_number;
  }

  let applicant_name = "";
  if (event.target.name === "applicant_name") {
    let applicant_nameErrors = [];
    // Applicant Name может быть необязательным
    applicant_name = applicant_nameErrors.join(", ");
    store.errorapplicant_name = applicant_name;
  }

  let approval_type = "";
  if (event.target.name === "approval_type") {
    let approval_typeErrors = [];
    // Approval Type может быть необязательным
    approval_type = approval_typeErrors.join(", ");
    store.errorapproval_type = approval_type;
  }

  let current_status = "";
  if (event.target.name === "current_status") {
    let current_statusErrors = [];
    // Status может быть необязательным
    current_status = current_statusErrors.join(", ");
    store.errorcurrent_status = current_status;
  }

  let priority = "";
  if (event.target.name === "priority") {
    let priorityErrors = [];
    // Priority может быть необязательным
    priority = priorityErrors.join(", ");
    store.errorpriority = priority;
  }

  const canSave = true 
    && organization_id === "" 
    && bga_application_number === "" 
    && applicant_name === ""
    && approval_type === ""
    && current_status === ""
    && priority === "";

  return canSave;
};